import { ReactNode, forwardRef, useState } from 'react';

type HoverLayerProps = {
  className?: string;
  children: ReactNode;
};
/**
 * HoverDisplayControlLayer
 *
 * hover されている場合のみ内部コンテンツをレンダリングするコンテナ
 */
const HoverDisplayControlLayer = forwardRef<HTMLDivElement, HoverLayerProps>(
  ({ className, children }, ref) => {
    const [hovered, setHovered] = useState(false);
    const onHover = () => setHovered(true);
    const onHoverLeave = () => setHovered(false);
    return (
      <div
        onMouseOver={onHover}
        onMouseLeave={onHoverLeave}
        className={className}
        ref={ref}
      >
        {hovered && children}
      </div>
    );
  }
);
HoverDisplayControlLayer.displayName === 'HoverDisplayControlLayer';
export default HoverDisplayControlLayer;
